import React from "react";
import ReactDOM from "react-dom";
import CssBaseline from "@material-ui/core/CssBaseline";
// import * as serviceworker from './serviceWorker'

import App from "./App";

// Meta puede completar OAuth redirigiendo el popup al frontend con el token
// en el hash en vez de resolver el callback del SDK. Entregar ese resultado
// a la ventana que abrió el popup antes de montar una segunda copia del CRM.
const metaOAuthParams = new URLSearchParams(window.location.hash.replace(/^#/, ""));
const metaAccessToken = metaOAuthParams.get("access_token");
const metaOAuthError = metaOAuthParams.get("error");

if ((metaAccessToken || metaOAuthError) && window.opener && window.opener !== window) {
	window.opener.postMessage(
		{
			type: "META_OAUTH_CALLBACK",
			accessToken: metaAccessToken,
			channel: localStorage.getItem("metaOAuthChannel"),
			state: metaOAuthParams.get("state"),
			error: metaOAuthError,
			errorDescription: metaOAuthParams.get("error_description"),
		},
		window.location.origin
	);

	window.history.replaceState({}, document.title, window.location.pathname);
	window.close();
}

ReactDOM.render(
	<CssBaseline>
		<App />
	</CssBaseline>,
	document.getElementById("root"),
	() => {
		window.finishProgress();
	}
);

// DESABILITADO TEMPORARIAMENTE - Service Worker causando problemas de cache
// serviceworker.register()

// Desregistrar service workers existentes para limpar cache antigo
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(function(registrations) {
    for(let registration of registrations) {
      registration.unregister();
      console.log('Service Worker desregistrado:', registration);
    }
  });
}
